<template>
	<div class="edit_wrap">
		<div class="edit_top">
			<div class="edit_tab" :class="{ 'active_tab': isStep === 1 }" @click="changeTab(1)">供应商信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 2 }" @click="changeTab(2)">品牌信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 3 }" @click="changeTab(3)">财务信息</div><!--
    --><div class="edit_tab" :class="{ 'active_tab': isStep === 4 }"  @click="changeTab(4)">合同协议</div>
		</div>
		<div class="tip_word">
			<el-row>
				<el-col :span="2">
					<div class="grid-content">友情提示：</div>
				</el-col>
				<el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<a target="_blank" href="/suppliers/index2/#/intro"><span style="color: #58b7ff">点击此处</span></a>查看供应商入驻介绍。</div></el-col>
			</el-row>
		</div>
		<basicInfo v-show="isStep == 1" ref="basicTemplate"></basicInfo>
		<brandList v-show="isStep == 2" ref="brandListTemplate"></brandList>
		<financeInfo v-show="isStep == 3" ></financeInfo>
		<argeementList  v-show="isStep == 4" ref="argeement"></argeementList>
		<div align="center" style="margin-top: 20px;" v-show="showButton == 1">
			<el-button  type="primary" icon="arrow-left" v-show="isStep > 1" @click="upPage">上一页</el-button>
			<el-button  type="primary" v-show="authData.hasFirstAudit == 1 && isStep == 3" @click="rejectFirstConfirmation">初审驳回</el-button>
			<el-button  type="primary" v-show="authData.hasFirstAudit == 1  && isStep == 3" @click="auditFirstConfirmation">初审通过</el-button>
			<el-button  type="primary" v-show="authData.hasConfirmContract == 1 && isStep == 4" @click="confirmAuditContract(0)">同意合同</el-button>
			<el-button  type="primary" v-show="authData.hasConfirmContract == 1 && isStep == 4" @click="confirmAuditContract(1)">不同意合同</el-button>
			<el-button  type="primary" v-show="authData.hasSecondAudit == 1 && isStep == 4" @click="confirmRejectQualification(1)">驳回资质信息</el-button>
			<el-button  type="primary" v-show="authData.hasSecondAudit == 1 && isStep == 4" @click="confirmRejectQualification(2)">驳回合同</el-button>
			<el-button  type="primary" v-show="authData.hasSecondAudit == 1 && isStep == 4" @click="confirmRejectQualification(0)">通过复审</el-button>
			<el-button  type="primary" v-show="authData.hasEditContract == 1 && isStep == 4" @click="pushContract">推送合同给供应商</el-button>
			<el-button  type="primary" v-show="isStep < 4" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
			<!-- <el-button type="primary" class="mr10" @click="confirmContract">
                 法务确认证件齐全(合同信息数据库暂时自己添加)
             </el-button>
             <el-button type="primary" class="mr10" @click="confirmDeposit">
                 财务确认收到保证金(合同信息数据库暂时自己添加)
             </el-button>
             <h1>链接格式如下所示：</h1>
             <h1>http://127.0.0.1:8010/#/supplier_apply_audit?supplierApplyId=65&agreementId=9</h1>-->
		</div>
	</div>
</template>

<script type="text/javascript">
	import basicInfo from './basicInfo.vue'
	import brandList from './brandList.vue'
	import financeInfo from './financeInfo.vue'
	import argeementList from './agreementList.vue'
    export default {
        components: {
            basicInfo: basicInfo,
            brandList: brandList,
            financeInfo: financeInfo,
            argeementList: argeementList
        },
        data () {
            return {
                showButton:1,
                argeementListShowButton:1,
                supplierApplyId:0,
                isActiveTab: true,
                isStep: 1,
				authData:{
                    supplierApplyId: 0,
                    status: 0,
                    statusDesc: "",
                    operType: 0,
                    hasFirstAudit: 0,//是否显示初审按钮 通过 | 驳回  1:显示 0:不显示
                    hasEditContract: 0,//是否显示编辑合同按钮 编辑|新增 | 推送 1:显示 0:不显示
                    hasConfirmContract: 0,////是否显示确认合同按钮 编辑|新增 | 推送 1:显示 0:不显示
                    hasSecondAudit: 0//是否显示复审按钮 通过 | 驳回资质 | 驳回合同 1:显示 0:不显示
				}
            }
        },
        methods: {
            changeTab(step){
                if(step==4 && this.argeementListShowButton==0) {
                    this.showButton = 0;
                }else{
                    this.showButton = 1;
				}
                this.isStep = step;
            },
            upPage(){
                this.showButton = 1;
                if(this.isStep>1) {
                    this.isStep = this.isStep - 1;
                }
            },
			nextPage(){
                if(this.isStep<4) {
                    if(this.isStep==3 && this.argeementListShowButton==0) {
                        this.showButton = 0;
                    }else{
                        this.showButton = 1;
                    }
                    this.isStep = this.isStep + 1;
                }
            },
            initUserApplyAuth(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findUserApplyAuth',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.authData = result.data;
                            that.$refs.argeement.hasEditContract = that.authData.hasEditContract;
                            that.$refs.brandListTemplate.hasSelBrandSAuth = that.authData.hasFirstAudit;
                            that.$refs.argeement.supplierEditContract = that.authData.hasConfirmContract;
                        }  else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            /**
             * 初审确认
             */
            auditFirstConfirmation() {
                var that = this;
                this.$confirm('确认供应商上传的信息都正确，可以提供法务审核。审核通过后，请继续补充与供应商的合同协议。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.auditFirst();
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消审核'
                    });
                });
            },

            /**
             * 初审
             */
            auditFirst () {
                var that = this;
                this.$prompt('请输入审核备注', '初审通过', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    $.get({
                        url: '/suppliers/supplierSettled/audit/first',
                        data: {
                            applyId: that.supplierApplyId,
                            reject:0,
                            content:value
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    message: '初审成功',
                                    type: 'success'
                                });
                                setTimeout(function () {
                                    that.changeTab(4);
                                    that.initUserApplyAuth(that.supplierApplyId);
                                },500)
                            } else {
                                that.showErrorMsg(result.msg, '初审失败，请联系管理员');
                            }
                        }
                    })
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消审核'
                    });
                });
            },

            rejectFirstConfirmation() {
                var that = this;
                this.$prompt('请输入驳回原因', '初审驳回', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                    inputErrorMessage: '请输入驳回原因'
                }).then(({ value }) => {
                    that.rejectFirst(value);
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消审核'
                    });
                });
            },

            rejectFirst (content) {
                var Data = {};
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/first',
                    data: {
                        applyId: that.supplierApplyId,
                        reject:1,
                        content:content
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                })
                            },500)
                        } else {
                            that.showErrorMsg(result.msg, '初审失败，驳回失败，请联系管理员');
                        }
                    }
                })
            },
            /**
			 * 确认合同/驳回合同
             */
            confirmAuditContract(reject) {
                var that = this;
                if(reject==0){//同意合同
                    that.$prompt('请输入备注', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(({ value }) => {
                        $.get({
                            url: '/suppliers/supplierSettled/audit/greement',
                            data: {
                                applyId: that.supplierApplyId,
                                reject:0,
                                content:value
                            },
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '合同确认成功',
                                        type: 'success'
                                    });
                                    setTimeout(function () {
                                        that.$router.push({
                                            path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                        })
                                    },500)
                                } else {
                                    that.showErrorMsg(result.msg, '合同确认失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
				}else if(reject==1) {//驳回合同
                    that.$prompt('请输入驳回合同原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                        inputErrorMessage: '请输入驳回原因'
                    }).then(({ value }) => {
                        $.get({
                            url: '/suppliers/supplierSettled/audit/greement',
                            data: {
                                applyId: that.supplierApplyId,
                                reject:1,
                                content:value
                            },
                            success: function(result) {
                                if (!result.code) {
                                    that.$message({
                                        message: '驳回合同成功',
                                        type: 'success'
                                    });

                                    setTimeout(function () {
                                        that.$router.push({
                                            path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                        })
                                    },500)
                                } else {
                                    that.$message.error('驳回合同失败，请联系管理员');
                                }
                            }
                        })
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
                }

            },
            /**
             * 驳回资质、驳回合同、复审通过
             */
            confirmRejectQualification(reject) {

                var that = this;
                if(reject==1){
                    this.$prompt('请输入驳回资质信息原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                        inputErrorMessage: '请输入驳回资质信息原因'
                    }).then(({ value }) => {
                        that.rejectQualification(value);
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '取消驳回资质'
                        });
                    });
				}else if(reject==2) {
                    this.$prompt('请输入驳回合同原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                        inputErrorMessage: '请输入驳回合同原因'
                    }).then(({ value }) => {
                        that.rejectContract(value);
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '取消驳回合同'
                        });
                    });
                }else if(reject==0) {

                    this.$prompt('请输入驳回合同原因', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputValidator:function(val){return (val==null || val.trim().length<1) ?false:true},
                        inputErrorMessage: '请输入驳回合同原因'
                    }).then(({ value }) => {
                        that.rejectContract(value);
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '取消驳回合同'
                        });
                    });

                    this.$confirm('确认审核通过', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$prompt('请输入审核备注', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        }).then(({ value }) => {
                            that.auditSecond(value);
                        }).catch(() => {
                            that.$message({
                                type: 'info',
                                message: '已取消复审'
                            });
                        });
                    }).catch(() => {
                        that.$message({
                            type: 'info',
                            message: '已取消复审'
                        });
                    });
                }
            },
            /**
             * 驳回资质
             * @param content
             */
            rejectQualification (content) {
                var Data = {};
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.supplierApplyId,
                        reject:1,
                        content:content
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                })
                            },500)
                        } else {
                            that.showErrorMsg(result.msg, '驳回失败，请联系管理员');
                        }
                    }
                })
            },
            /**
             * 驳回合同
             * @param content
             */
            rejectContract (content) {
                var Data = {};
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.supplierApplyId,
                        reject:2,
                        content:content
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '驳回成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                })
                            },500)
                        } else {
                            that.showErrorMsg(result.msg, '驳回失败，请联系管理员');
                        }
                    }
                })
            },
            /**
			 * 复审通过
             */
            auditSecond (value) {
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/audit/second',
                    data: {
                        applyId: that.supplierApplyId,
                        reject:0,
                        content:value
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.$message({
                                message: '复审成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                })
                            },500)
                        } else {
                            that.showErrorMsg(result.msg, '复审失败，请联系管理员');
                        }
                    }
                })
            },
            /**
			 * 推送合同
             */
            pushContract() {
                var that = this;
                var Data = {
                    applyId:that.supplierApplyId
                };
                $.ajax({
                    url: '/suppliers/supplierSettled/audit/pushAgreement?applyId=' + that.supplierApplyId,
                    //data: JSON.stringify(Data),
                    //dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'GET',
                    success: function (result) {
                        if (!result.code) {
                            // 后台成功 改变路由
                            // that.showDetail = 1;
                            that.$message({
                                message: '推送合同成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                that.$router.push({
                                    path:'/supplier_skan?supplierApplyId=' + that.supplierApplyId
                                })
                            },500)
                            // that.initAgreementList(supplierApplyId);
                        } else {
                            that.showErrorMsg(result.msg, '推送合同失败，请联系管理员');
                        }
                    }
                })
            },
			showErrorMsg(msg,defaultMsg){
				if(msg) {
                    this.$message.error(msg);
                }else{
                    this.$message.error(defaultMsg);
				}
            }

        },
		mounted(){
            this.supplierApplyId = this.$route.query.supplierApplyId;
            var step=this.$route.query.isStep;
            step = step * 1;
            if(step && step>1 && step <5) {
                this.changeTab(step);
            }
            this.initUserApplyAuth(this.supplierApplyId);
		}
    };
</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  // padding: 20px;
	  .edit_tab {
	  	display: inline-block;
	  	width: 262px;
	  	height: 46px;
	  	text-align: center;
	  	line-height: 46px;
	  	color: #fff;
	  	background: #ff6c83;
	  }
	  .active_tab {
	  	background: #ff4a7d;
	  }
	  .tip_word {
	  	margin-top: 20px;
	  	width: 1048px;
	  	height: 160px;
	  	background: #f9f9f9;
	  	padding: 10px;
	  }
	}
	.lh20 {
		line-height: 20px;
	}
</style>


// WEBPACK FOOTER //
// supplierCommonPages.vue?3b06a80e